import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { model_eval_template } from "../components/templates/model_eval_template";
import { getAllBrandsFromVnAppZone } from "../utils/BrandHelper";

declare var ko: any;

const EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const EXCERPT_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const TITLE_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const CATEGORY_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const TAG_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const THREAD_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const SEO_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const SMO_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4o-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

const FACT_CHECK_EVAL_MODELS: Array<{ key: string; cell: string }> = [
    { key: "perplexity-sonar", cell: "perplexity_sonar" },
    { key: "gpt-5-nano", cell: "gpt5_nano" },
    { key: "gpt-4.1-mini", cell: "gpt4o_mini" },
    { key: "gpt-5-mini", cell: "gpt5_mini" },
];

export class model_eval extends vnModule_knockoutJS {

    protected modelEvalTemplate!: model_eval_template;
    protected XHRHdl!: XMLHttpRequestHandler;
    protected runAbortController: AbortController | null = null;

    protected getModuleName(): string {
        return "model_eval";
    }

    public buildContent(): Array<Element> {

        this.modelEvalTemplate = new model_eval_template("model_eval", this.viewModel, this);
        return [this.modelEvalTemplate.build()];
    }

    public fillPage(): void {
        this.modelEvalTemplate.setupTabScroller();
        this.initExcerptBrands();
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (!vm.rows().length) {
            vm.runStatus("Select Fetch to load fixtures");
        }
    }

    private initExcerptBrands(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const userBrands: any[] = (getAllBrandsFromVnAppZone(this.getVnAppZone()) as any) || [];
        const brands = userBrands
            .filter((brand: any) => brand && !brand.isDeleted)
            .map((brand: any) => ({
                id: brand.id,
                name: brand.name,
                shortName: brand.shortName || brand.short_name || "",
                domain: brand.domain || "",
            }))
            .sort((a: any, b: any) => String(a.name).localeCompare(String(b.name)));

        vm.excerptBrands(brands);
        if (!vm.excerptIdBrand() && brands.length) {
            vm.excerptIdBrand(brands[0].id);
        }
        if (!vm.titleIdBrand() && brands.length) {
            vm.titleIdBrand(brands[0].id);
        }
        if (!vm.categoryIdBrand() && brands.length) {
            vm.categoryIdBrand(brands[0].id);
        }
        if (!vm.tagIdBrand() && brands.length) {
            vm.tagIdBrand(brands[0].id);
        }
        if (!vm.threadIdBrand() && brands.length) {
            vm.threadIdBrand(brands[0].id);
        }
        if (!vm.seoIdBrand() && brands.length) {
            vm.seoIdBrand(brands[0].id);
        }
        if (!vm.smoIdBrand() && brands.length) {
            vm.smoIdBrand(brands[0].id);
        }
        if (!vm.factCheckIdBrand() && brands.length) {
            vm.factCheckIdBrand(brands[0].id);
        }
        if (!vm.excerptRows().length) {
            vm.excerptRunStatus(vm.excerptIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.titleRows().length) {
            vm.titleRunStatus(vm.titleIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.categoryRows().length) {
            vm.categoryRunStatus(vm.categoryIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.tagRows().length) {
            vm.tagRunStatus(vm.tagIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.threadRows().length) {
            vm.threadRunStatus(vm.threadIdBrand() ? "Select Fetch to load Thread fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.seoRows().length) {
            vm.seoRunStatus(vm.seoIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.smoRows().length) {
            vm.smoRunStatus(vm.smoIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
        if (!vm.factCheckRows().length) {
            vm.factCheckRunStatus(vm.factCheckIdBrand() ? "Select Fetch to load fixtures" : "Select a brand, then Fetch");
        }
    }

    public changePrimaryTab(tab: string): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning() || vm.selectedTab() === tab) {
            return;
        }
        vm.selectedTab(tab);
        if (tab === "emaki_article_assistant") {
            window.setTimeout(() => this.modelEvalTemplate.setupTabScroller(), 0);
        }
    }

    public changeArticleAssistantTab(tab: string): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning() || vm.selectedArticleAssistantTab() === tab) {
            return;
        }
        vm.selectedArticleAssistantTab(tab);
        window.setTimeout(() => this.modelEvalTemplate.updateTabScrollState(), 0);
    }

    public changeExcerptBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.excerptRows([]);
        vm.excerptRunStatus(vm.excerptIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchExcerptFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadExcerptFixtures();
    }

    public changeTitleBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.titleRows([]);
        vm.titleRunStatus(vm.titleIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchTitleFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadTitleFixtures();
    }

    public changeCategoryBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.categoryRows([]);
        vm.categoryRunStatus(vm.categoryIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchCategoryFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadCategoryFixtures();
    }

    public changeTagBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.tagRows([]);
        vm.tagRunStatus(vm.tagIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchTagFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadTagFixtures();
    }

    public changeThreadBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.threadRows([]);
        vm.threadRunStatus(vm.threadIdBrand() ? "Select Fetch to load Thread fixtures" : "");
    }

    public fetchThreadFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadThreadFixtures();
    }

    public changeSeoBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.seoRows([]);
        vm.seoRunStatus(vm.seoIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchSeoFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadSeoFixtures();
    }

    public changeSmoBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.smoRows([]);
        vm.smoRunStatus(vm.smoIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchSmoFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadSmoFixtures();
    }

    public changeFactCheckBrand(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        vm.factCheckRows([]);
        vm.factCheckRunStatus(vm.factCheckIdBrand() ? "Select Fetch to load fixtures" : "");
    }

    public fetchFactCheckFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadFactCheckFixtures();
    }

    public changeType(type: string): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning() || vm.selectedType() === type) {
            return;
        }
        vm.selectedType(type);
        vm.customCommentText("");
        vm.customRunStatus("");
        this.modelEvalTemplate.resetCustomRow("");
        vm.rows([]);
        vm.runStatus("Select Fetch to load fixtures");
    }

    public fetchToxicityFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        this.loadFixtures();
    }

    private loadFixtures(): void {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        const type = this.modelEvalTemplate.getTemplateViewModel().selectedType();
        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/comment-toxicity/fixtures/?type=" + encodeURIComponent(type),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadExcerptFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.excerptIdBrand();
        if (!idBrand) {
            vm.excerptRows([]);
            vm.excerptRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/excerpts/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onExcerptFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadTitleFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.titleIdBrand();
        if (!idBrand) {
            vm.titleRows([]);
            vm.titleRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/titles/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onTitleFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadCategoryFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.categoryIdBrand();
        if (!idBrand) {
            vm.categoryRows([]);
            vm.categoryRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/categories/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onCategoryFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadTagFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.tagIdBrand();
        if (!idBrand) {
            vm.tagRows([]);
            vm.tagRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/tags/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onTagFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadThreadFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.threadIdBrand();
        if (!idBrand) {
            vm.threadRows([]);
            vm.threadRunStatus("Select a brand to load Thread article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/threads/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onThreadFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadSeoFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.seoIdBrand();
        if (!idBrand) {
            vm.seoRows([]);
            vm.seoRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/seo/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onSeoFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadSmoFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.smoIdBrand();
        if (!idBrand) {
            vm.smoRows([]);
            vm.smoRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/smo/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onSmoFixturesReturn;
        this.XHRHdl.execute();
    }

    private loadFactCheckFixtures(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        const idBrand = vm.factCheckIdBrand();
        if (!idBrand) {
            vm.factCheckRows([]);
            vm.factCheckRunStatus("Select a brand to load article fixtures");
            return;
        }

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.modelEvalTemplate.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(
            "/api/model-eval/fact-check/fixtures/?idBrand=" + encodeURIComponent(String(idBrand)),
            [],
            this
        );
        this.XHRHdl.onReadyStateFunction = this.onFactCheckFixturesReturn;
        this.XHRHdl.execute();
    }

    protected onFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyPromptConfig({
                    systemPrompt: response.systemPrompt,
                    includeExplanation: !!response.includeExplanation,
                });
                obj.modelEvalTemplate.setFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onExcerptFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyExcerptPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setExcerptFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onTitleFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyTitlePromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setTitleFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onCategoryFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyCategoryPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setCategoryFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onTagFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyTagPromptConfig({
                    step1SystemPrompt: response.step1SystemPrompt,
                    step2SystemPromptTemplate: response.step2SystemPromptTemplate,
                }, true);
                obj.modelEvalTemplate.setTagFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onThreadFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyThreadPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setThreadFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onSeoFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applySeoPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setSeoFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onSmoFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applySmoPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setSmoFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    protected onFactCheckFixturesReturn(req: any, obj: any): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.modelEvalTemplate.applyFactCheckPromptConfig({
                    systemPrompt: response.systemPrompt,
                }, true);
                obj.modelEvalTemplate.setFactCheckFixtures(response.fixtures || []);
            });
            obj.loadingOut(obj.modelEvalTemplate.builtTemplate);
        };
    }

    public runAllEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const rows = vm.rows();
        if (!rows.length) {
            vm.runStatus("No fixtures to evaluate");
            return;
        }

        const systemPrompt = String(vm.systemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.runStatus("System prompt is required");
            return;
        }

        const signal = this.beginRun();
        vm.isRunning(true);
        this.runFixtureNext(rows, 0, 0, systemPrompt, vm.selectedType(), signal)
            .then(() => {
                vm.runStatus("Done");
            })
            .catch((error) => {
                vm.runStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public stopEvaluations(): void {
        if (this.runAbortController) {
            this.runAbortController.abort();
        }
    }

    public runCustomCommentEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const commentText = String(vm.customCommentText() || "").trim();
        if (!commentText) {
            vm.customRunStatus("Enter content first");
            return;
        }

        const systemPrompt = String(vm.systemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.customRunStatus("System prompt is required");
            return;
        }

        this.modelEvalTemplate.resetCustomRow(commentText);
        const customRow = vm.customRow();

        const signal = this.beginRun();
        vm.isRunning(true);
        vm.customRunStatus("Running…");
        this.runModelSequence(customRow, systemPrompt, commentText, vm.selectedType(), 0, signal)
            .then(() => {
                vm.customRunStatus("Done");
            })
            .catch((error) => {
                vm.customRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllExcerptEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const rows = vm.excerptRows();
        if (!rows.length) {
            vm.excerptRunStatus("No fixtures to evaluate");
            return;
        }

        const systemPrompt = String(vm.excerptSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.excerptRunStatus("System prompt is required");
            return;
        }

        const signal = this.beginRun();
        vm.isRunning(true);
        this.runExcerptFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => {
                vm.excerptRunStatus("Done");
            })
            .catch((error) => {
                vm.excerptRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomExcerptEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const title = String(vm.excerptCustomTitle() || "").trim();
        const content = String(vm.excerptCustomContent() || "").trim();
        if (!title || !content) {
            vm.excerptCustomRunStatus("Enter title and content first");
            return;
        }

        const systemPrompt = String(vm.excerptSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.excerptCustomRunStatus("System prompt is required");
            return;
        }

        this.modelEvalTemplate.resetExcerptCustomRow(title, content);
        const customRow = vm.excerptCustomRow();

        const signal = this.beginRun();
        vm.isRunning(true);
        vm.excerptCustomRunStatus("Running…");
        this.runExcerptModelSequence(customRow, systemPrompt, title, content, 0, signal)
            .then(() => {
                vm.excerptCustomRunStatus("Done");
            })
            .catch((error) => {
                vm.excerptCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllTitleEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const rows = vm.titleRows();
        if (!rows.length) {
            vm.titleRunStatus("No fixtures to evaluate");
            return;
        }

        const systemPrompt = String(vm.titleSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.titleRunStatus("System prompt is required");
            return;
        }

        const signal = this.beginRun();
        vm.isRunning(true);
        this.runTitleFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => {
                vm.titleRunStatus("Done");
            })
            .catch((error) => {
                vm.titleRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomTitleEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }

        const title = String(vm.titleCustomTitle() || "").trim();
        const content = String(vm.titleCustomContent() || "").trim();
        if (!title || !content) {
            vm.titleCustomRunStatus("Enter title and content first");
            return;
        }

        const systemPrompt = String(vm.titleSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.titleCustomRunStatus("System prompt is required");
            return;
        }

        this.modelEvalTemplate.resetTitleCustomRow(title, content);
        const customRow = vm.titleCustomRow();

        const signal = this.beginRun();
        vm.isRunning(true);
        vm.titleCustomRunStatus("Running…");
        this.runTitleModelSequence(customRow, systemPrompt, title, content, 0, signal)
            .then(() => {
                vm.titleCustomRunStatus("Done");
            })
            .catch((error) => {
                vm.titleCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllCategoryEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.categoryRows();
        if (!rows.length) {
            vm.categoryRunStatus("No fixtures to evaluate");
            return;
        }
        const systemPrompt = String(vm.categorySystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.categoryRunStatus("System prompt is required");
            return;
        }
        if (!vm.categoryIdBrand()) {
            vm.categoryRunStatus("Select a brand first");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runCategoryFixtureNext(rows, 0, 0, systemPrompt, Number(vm.categoryIdBrand()), signal)
            .then(() => { vm.categoryRunStatus("Done"); })
            .catch((error) => {
                vm.categoryRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomCategoryEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.categoryCustomTitle() || "").trim();
        const content = String(vm.categoryCustomContent() || "").trim();
        if (!title || !content) {
            vm.categoryCustomRunStatus("Enter title and content first");
            return;
        }
        const systemPrompt = String(vm.categorySystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.categoryCustomRunStatus("System prompt is required");
            return;
        }
        if (!vm.categoryIdBrand()) {
            vm.categoryCustomRunStatus("Select a brand first");
            return;
        }
        this.modelEvalTemplate.resetCategoryCustomRow(title, content);
        const customRow = vm.categoryCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.categoryCustomRunStatus("Running…");
        this.runCategoryModelSequence(customRow, systemPrompt, title, content, Number(vm.categoryIdBrand()), 0, signal)
            .then(() => { vm.categoryCustomRunStatus("Done"); })
            .catch((error) => {
                vm.categoryCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllTagEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.tagRows();
        if (!rows.length) {
            vm.tagRunStatus("No fixtures to evaluate");
            return;
        }
        const step1 = String(vm.tagStep1SystemPrompt() || "").trim();
        const step2 = String(vm.tagStep2SystemPromptTemplate() || "").trim();
        if (!step1 || !step2) {
            vm.tagRunStatus("Both step prompts are required");
            return;
        }
        if (!vm.tagIdBrand()) {
            vm.tagRunStatus("Select a brand first");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runTagFixtureNext(rows, 0, 0, step1, step2, Number(vm.tagIdBrand()), signal)
            .then(() => { vm.tagRunStatus("Done"); })
            .catch((error) => {
                vm.tagRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomTagEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.tagCustomTitle() || "").trim();
        const content = String(vm.tagCustomContent() || "").trim();
        if (!title || !content) {
            vm.tagCustomRunStatus("Enter title and content first");
            return;
        }
        const step1 = String(vm.tagStep1SystemPrompt() || "").trim();
        const step2 = String(vm.tagStep2SystemPromptTemplate() || "").trim();
        if (!step1 || !step2) {
            vm.tagCustomRunStatus("Both step prompts are required");
            return;
        }
        if (!vm.tagIdBrand()) {
            vm.tagCustomRunStatus("Select a brand first");
            return;
        }
        this.modelEvalTemplate.resetTagCustomRow(title, content);
        const customRow = vm.tagCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.tagCustomRunStatus("Running…");
        this.runTagModelSequence(customRow, step1, step2, title, content, Number(vm.tagIdBrand()), 0, signal)
            .then(() => { vm.tagCustomRunStatus("Done"); })
            .catch((error) => {
                vm.tagCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllThreadEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.threadRows();
        if (!rows.length) {
            vm.threadRunStatus("No fixtures to evaluate");
            return;
        }
        const systemPrompt = String(vm.threadSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.threadRunStatus("System prompt is required");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runThreadFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => { vm.threadRunStatus("Done"); })
            .catch((error) => {
                vm.threadRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomThreadEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.threadCustomTitle() || "").trim();
        const content = String(vm.threadCustomContent() || "").trim();
        if (!title || !content) {
            vm.threadCustomRunStatus("Enter title and content first");
            return;
        }
        const systemPrompt = String(vm.threadSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.threadCustomRunStatus("System prompt is required");
            return;
        }
        this.modelEvalTemplate.resetThreadCustomRow(title, content);
        const customRow = vm.threadCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.threadCustomRunStatus("Running…");
        this.runThreadModelSequence(customRow, systemPrompt, title, content, 0, signal)
            .then(() => { vm.threadCustomRunStatus("Done"); })
            .catch((error) => {
                vm.threadCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllSeoEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.seoRows();
        if (!rows.length) {
            vm.seoRunStatus("No fixtures to evaluate");
            return;
        }
        const systemPrompt = String(vm.seoSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.seoRunStatus("System prompt is required");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runSeoFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => { vm.seoRunStatus("Done"); })
            .catch((error) => {
                vm.seoRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomSeoEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.seoCustomTitle() || "").trim();
        const content = String(vm.seoCustomContent() || "").trim();
        if (!title || !content) {
            vm.seoCustomRunStatus("Enter title and content first");
            return;
        }
        const systemPrompt = String(vm.seoSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.seoCustomRunStatus("System prompt is required");
            return;
        }
        this.modelEvalTemplate.resetSeoCustomRow(title, content);
        const customRow = vm.seoCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.seoCustomRunStatus("Running…");
        this.runSeoModelSequence(customRow, systemPrompt, title, content, 0, signal)
            .then(() => { vm.seoCustomRunStatus("Done"); })
            .catch((error) => {
                vm.seoCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllSmoEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.smoRows();
        if (!rows.length) {
            vm.smoRunStatus("No fixtures to evaluate");
            return;
        }
        const systemPrompt = String(vm.smoSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.smoRunStatus("System prompt is required");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runSmoFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => { vm.smoRunStatus("Done"); })
            .catch((error) => {
                vm.smoRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomSmoEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.smoCustomTitle() || "").trim();
        const content = String(vm.smoCustomContent() || "").trim();
        if (!title || !content) {
            vm.smoCustomRunStatus("Enter title and content first");
            return;
        }
        const systemPrompt = String(vm.smoSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.smoCustomRunStatus("System prompt is required");
            return;
        }
        this.modelEvalTemplate.resetSmoCustomRow(title, content);
        const customRow = vm.smoCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.smoCustomRunStatus("Running…");
        this.runSmoModelSequence(customRow, systemPrompt, title, content, 0, signal)
            .then(() => { vm.smoCustomRunStatus("Done"); })
            .catch((error) => {
                vm.smoCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runAllFactCheckEvaluations(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const rows = vm.factCheckRows();
        if (!rows.length) {
            vm.factCheckRunStatus("No fixtures to evaluate");
            return;
        }
        const systemPrompt = String(vm.factCheckSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.factCheckRunStatus("System prompt is required");
            return;
        }
        const signal = this.beginRun();
        vm.isRunning(true);
        this.runFactCheckFixtureNext(rows, 0, 0, systemPrompt, signal)
            .then(() => { vm.factCheckRunStatus("Done"); })
            .catch((error) => {
                vm.factCheckRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Run all failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public runCustomFactCheckEvaluation(): void {
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        if (vm.isRunning()) {
            return;
        }
        const title = String(vm.factCheckCustomTitle() || "").trim();
        const content = String(vm.factCheckCustomContent() || "").trim();
        if (!content) {
            vm.factCheckCustomRunStatus("Enter content first");
            return;
        }
        const systemPrompt = String(vm.factCheckSystemPrompt() || "").trim();
        if (!systemPrompt) {
            vm.factCheckCustomRunStatus("System prompt is required");
            return;
        }
        this.modelEvalTemplate.resetFactCheckCustomRow(title, content);
        const customRow = vm.factCheckCustomRow();
        const signal = this.beginRun();
        vm.isRunning(true);
        vm.factCheckCustomRunStatus("Running…");
        this.runFactCheckModelSequence(customRow, systemPrompt, content, 0, signal)
            .then(() => { vm.factCheckCustomRunStatus("Done"); })
            .catch((error) => {
                vm.factCheckCustomRunStatus(this.isAbortError(error) ? "Stopped" : (error && error.message ? error.message : "Custom run failed"));
            })
            .then(() => {
                this.endRun();
                vm.isRunning(false);
            });
    }

    public sendCustomPromptMessage(chat: any): void {
        if (!chat || chat.isLoading()) {
            return;
        }

        const message = String(chat.input() || "").trim();
        if (!message) {
            chat.status("Enter a message first");
            return;
        }

        chat.messages.push({
            role: "user",
            content: message,
            contentHtml: "",
            rawContent: message,
            searchResults: [],
        });
        chat.input("");
        chat.isLoading(true);
        chat.status("Running…");

        this.evaluateCustomPrompt({
            model: chat.model,
            message,
            previousResponseId: String(chat.previousResponseId() || ""),
            messages: this.getCustomPromptMessageHistory(chat),
        })
            .then((result) => {
                chat.messages.push({
                    role: "assistant",
                    content: "",
                    contentHtml: typeof result.contentHtml === "string" ? result.contentHtml : "",
                    rawContent: result && result.raw && typeof result.raw.content === "string" ? result.raw.content : "",
                    searchResults: Array.isArray(result.searchResults) ? result.searchResults : [],
                });
                if (typeof result.responseId === "string" && result.responseId !== "") {
                    chat.previousResponseId(result.responseId);
                }
                chat.status(this.formatDurationLabel(result.durationMs));
            })
            .catch((error) => {
                chat.status(error && error.message ? error.message : "Custom prompt failed");
            })
            .then(() => {
                chat.isLoading(false);
            });
    }

    private getCustomPromptMessageHistory(chat: any): Array<{ role: string; content: string }> {
        return (chat.messages() || [])
            .map((message: any) => ({
                role: message.role === "assistant" ? "assistant" : "user",
                content: String(message.rawContent || message.content || ""),
            }))
            .filter((message: { role: string; content: string }) => message.content.trim() !== "");
    }

    private beginRun(): AbortSignal {
        if (this.runAbortController) {
            this.runAbortController.abort();
        }
        this.runAbortController = new AbortController();
        return this.runAbortController.signal;
    }

    private endRun(): void {
        this.runAbortController = null;
    }

    private isAbortError(error: any): boolean {
        return !!(error && (error.name === "AbortError" || error.message === "Stopped"));
    }

    private throwIfAborted(signal: AbortSignal): void {
        if (signal.aborted) {
            const error: any = new Error("Stopped");
            error.name = "AbortError";
            throw error;
        }
    }

    private rejectedIfAborted(signal: AbortSignal): Promise<void> | null {
        if (!signal.aborted) {
            return null;
        }
        const error: any = new Error("Stopped");
        error.name = "AbortError";
        return Promise.reject(error);
    }

    private runFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        type: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }

        if (modelIndex >= EVAL_MODELS.length) {
            return this.runFixtureNext(rows, rowIndex + 1, 0, systemPrompt, type, signal);
        }

        const row = rows[rowIndex];
        const modelDef = EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.runStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateCell({
            commentText: row.commentText,
            type: type,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null
                );
            })
            .then(() => this.runFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, type, signal));
    }

    private runModelSequence(
        row: any,
        systemPrompt: string,
        commentText: string,
        type: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (modelIndex >= EVAL_MODELS.length) {
            return Promise.resolve();
        }

        const modelDef = EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.customRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateCell({
            commentText: commentText,
            type: type,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null
                );
            })
            .then(() => this.runModelSequence(row, systemPrompt, commentText, type, modelIndex + 1, signal));
    }

    private runExcerptFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }

        if (modelIndex >= EXCERPT_EVAL_MODELS.length) {
            return this.runExcerptFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }

        const row = rows[rowIndex];
        const modelDef = EXCERPT_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.excerptRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateExcerptCell({
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyExcerptEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyExcerptEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runExcerptFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runExcerptModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (modelIndex >= EXCERPT_EVAL_MODELS.length) {
            return Promise.resolve();
        }

        const modelDef = EXCERPT_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.excerptCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateExcerptCell({
            title: title,
            content: content,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyExcerptEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyExcerptEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runExcerptModelSequence(row, systemPrompt, title, content, modelIndex + 1, signal));
    }

    private runTitleFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }

        if (modelIndex >= TITLE_EVAL_MODELS.length) {
            return this.runTitleFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }

        const row = rows[rowIndex];
        const modelDef = TITLE_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.titleRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateTitleCell({
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runTitleFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runTitleModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }

        if (modelIndex >= TITLE_EVAL_MODELS.length) {
            return Promise.resolve();
        }

        const modelDef = TITLE_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();

        vm.titleCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");

        return this.evaluateTitleCell({
            title: title,
            content: content,
            model: modelDef.key,
            systemPrompt: systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                const message = error && error.message ? error.message : "Evaluation failed";
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    message,
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runTitleModelSequence(row, systemPrompt, title, content, modelIndex + 1, signal));
    }

    private runCategoryFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        idBrand: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= CATEGORY_EVAL_MODELS.length) {
            return this.runCategoryFixtureNext(rows, rowIndex + 1, 0, systemPrompt, idBrand, signal);
        }
        const row = rows[rowIndex];
        const modelDef = CATEGORY_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.categoryRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateCategoryCell({
            idBrand,
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runCategoryFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, idBrand, signal));
    }

    private runCategoryModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        idBrand: number,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= CATEGORY_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = CATEGORY_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.categoryCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateCategoryCell({
            idBrand,
            title,
            content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runCategoryModelSequence(row, systemPrompt, title, content, idBrand, modelIndex + 1, signal));
    }

    private runTagFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        step1SystemPrompt: string,
        step2SystemPromptTemplate: string,
        idBrand: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= TAG_EVAL_MODELS.length) {
            return this.runTagFixtureNext(rows, rowIndex + 1, 0, step1SystemPrompt, step2SystemPromptTemplate, idBrand, signal);
        }
        const row = rows[rowIndex];
        const modelDef = TAG_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.tagRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateTagCell({
            idBrand,
            title: row.title,
            content: row.content,
            model: modelDef.key,
            step1SystemPrompt,
            step2SystemPromptTemplate,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runTagFixtureNext(rows, rowIndex, modelIndex + 1, step1SystemPrompt, step2SystemPromptTemplate, idBrand, signal));
    }

    private runTagModelSequence(
        row: any,
        step1SystemPrompt: string,
        step2SystemPromptTemplate: string,
        title: string,
        content: string,
        idBrand: number,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= TAG_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = TAG_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.tagCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateTagCell({
            idBrand,
            title,
            content,
            model: modelDef.key,
            step1SystemPrompt,
            step2SystemPromptTemplate,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runTagModelSequence(row, step1SystemPrompt, step2SystemPromptTemplate, title, content, idBrand, modelIndex + 1, signal));
    }

    private runThreadFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= THREAD_EVAL_MODELS.length) {
            return this.runThreadFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }
        const row = rows[rowIndex];
        const modelDef = THREAD_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.threadRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateThreadCell({
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runThreadFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runThreadModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= THREAD_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = THREAD_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.threadCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateThreadCell({
            title,
            content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyTitleEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyTitleEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runThreadModelSequence(row, systemPrompt, title, content, modelIndex + 1, signal));
    }

    private runSeoFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= SEO_EVAL_MODELS.length) {
            return this.runSeoFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }
        const row = rows[rowIndex];
        const modelDef = SEO_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.seoRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateSeoCell({
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applySeoEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applySeoEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runSeoFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runSeoModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= SEO_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = SEO_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.seoCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateSeoCell({
            title,
            content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applySeoEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applySeoEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runSeoModelSequence(row, systemPrompt, title, content, modelIndex + 1, signal));
    }

    private runSmoFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= SMO_EVAL_MODELS.length) {
            return this.runSmoFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }
        const row = rows[rowIndex];
        const modelDef = SMO_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.smoRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateSmoCell({
            title: row.title,
            content: row.content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applySmoEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applySmoEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runSmoFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runSmoModelSequence(
        row: any,
        systemPrompt: string,
        title: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= SMO_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = SMO_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.smoCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateSmoCell({
            title,
            content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applySmoEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applySmoEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runSmoModelSequence(row, systemPrompt, title, content, modelIndex + 1, signal));
    }

    private runFactCheckFixtureNext(
        rows: any[],
        rowIndex: number,
        modelIndex: number,
        systemPrompt: string,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (rowIndex >= rows.length) {
            return Promise.resolve();
        }
        if (modelIndex >= FACT_CHECK_EVAL_MODELS.length) {
            return this.runFactCheckFixtureNext(rows, rowIndex + 1, 0, systemPrompt, signal);
        }
        const row = rows[rowIndex];
        const modelDef = FACT_CHECK_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.factCheckRunStatus("Row " + (rowIndex + 1) + "/" + rows.length + " · " + modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateFactCheckCell({
            content: row.content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyFactCheckEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyFactCheckEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runFactCheckFixtureNext(rows, rowIndex, modelIndex + 1, systemPrompt, signal));
    }

    private runFactCheckModelSequence(
        row: any,
        systemPrompt: string,
        content: string,
        modelIndex: number,
        signal: AbortSignal
    ): Promise<void> {
        const aborted = this.rejectedIfAborted(signal);
        if (aborted) {
            return aborted;
        }
        if (modelIndex >= FACT_CHECK_EVAL_MODELS.length) {
            return Promise.resolve();
        }
        const modelDef = FACT_CHECK_EVAL_MODELS[modelIndex];
        const cell = row[modelDef.cell];
        const vm = this.modelEvalTemplate.getTemplateViewModel();
        vm.factCheckCustomRunStatus(modelDef.key);
        cell.status("loading");
        cell.error("");
        return this.evaluateFactCheckCell({
            content,
            model: modelDef.key,
            systemPrompt,
        }, signal)
            .then((result) => {
                this.throwIfAborted(signal);
                this.modelEvalTemplate.applyFactCheckEvaluationResult(cell, result);
            })
            .catch((error) => {
                if (this.isAbortError(error)) {
                    if (cell.status() === "loading") {
                        cell.status("idle");
                        cell.error("");
                    }
                    throw error;
                }
                this.modelEvalTemplate.applyFactCheckEvaluationError(
                    cell,
                    error && error.message ? error.message : "Evaluation failed",
                    error && error.durationMs != null ? error.durationMs : null,
                    error && error.rawResponse != null ? error.rawResponse : null
                );
            })
            .then(() => this.runFactCheckModelSequence(row, systemPrompt, content, modelIndex + 1, signal));
    }

    private evaluateCell(payload: {
        commentText: string;
        type: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/comment-toxicity/evaluate/", payload, signal);
    }

    private evaluateExcerptCell(payload: {
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/excerpts/evaluate/", payload, signal);
    }

    private evaluateTitleCell(payload: {
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/titles/evaluate/", payload, signal);
    }

    private evaluateCategoryCell(payload: {
        idBrand: number;
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/categories/evaluate/", payload, signal);
    }

    private evaluateTagCell(payload: {
        idBrand: number;
        title: string;
        content: string;
        model: string;
        step1SystemPrompt: string;
        step2SystemPromptTemplate: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/tags/evaluate/", payload, signal);
    }

    private evaluateThreadCell(payload: {
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/threads/evaluate/", payload, signal);
    }

    private evaluateSeoCell(payload: {
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/seo/evaluate/", payload, signal);
    }

    private evaluateSmoCell(payload: {
        title: string;
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/smo/evaluate/", payload, signal);
    }

    private evaluateFactCheckCell(payload: {
        content: string;
        model: string;
        systemPrompt: string;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/fact-check/evaluate/", payload, signal);
    }

    private evaluateCustomPrompt(payload: {
        model: string;
        message: string;
        previousResponseId: string;
        messages: Array<{ role: string; content: string }>;
    }, signal?: AbortSignal): Promise<any> {
        return this.fetchTimed("/api/model-eval/custom-prompt/evaluate/", payload, signal);
    }

    private formatDurationLabel(durationMs: any): string {
        if (durationMs === null || durationMs === undefined || isNaN(Number(durationMs))) {
            return "";
        }
        const ms = Math.max(0, Number(durationMs));
        if (ms < 1000) {
            return "time: " + Math.round(ms) + "ms";
        }
        return "time: " + (ms / 1000).toFixed(2) + "s";
    }

    private fetchTimed(url: string, payload: any, signal?: AbortSignal): Promise<any> {
        const startedAt = (typeof performance !== "undefined" && performance.now)
            ? performance.now()
            : Date.now();

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
            signal: signal,
        }).then((response) => {
            return response.json().then((body) => {
                return { response, payload: body };
            }).catch(() => {
                return { response, payload: null };
            });
        }).then((result) => {
            const endedAt = (typeof performance !== "undefined" && performance.now)
                ? performance.now()
                : Date.now();
            const durationMs = Math.max(0, endedAt - startedAt);

            if (!result.response.ok) {
                const message = this.extractErrorMessage(result.payload) || ("HTTP " + result.response.status);
                const error: any = new Error(message);
                error.durationMs = durationMs;
                error.rawResponse = result.payload;
                throw error;
            }

            const body = result.payload && typeof result.payload === "object"
                ? result.payload
                : {};
            body.durationMs = durationMs;
            return body;
        });
    }

    private extractErrorMessage(payload: any): string {
        if (!payload) {
            return "";
        }
        const validations = payload.validations || payload.errors;
        if (validations && validations[0] && validations[0].messages && validations[0].messages[0]) {
            return validations[0].messages[0];
        }
        if (typeof payload.message === "string") {
            return payload.message;
        }
        if (typeof payload.error === "string") {
            return payload.error;
        }
        return "";
    }
}



// WEBPACK FOOTER //
// ./js/modules/model_eval.ts